module.exports = __webpack_public_path__ + "media/mobile-header-kz.1c25bb11.mp4";